import { render, staticRenderFns } from "./DivTable.vue?vue&type=template&id=4973a7b9"
import script from "./DivTable.vue?vue&type=script&lang=js"
export * from "./DivTable.vue?vue&type=script&lang=js"
import style0 from "./DivTable.vue?vue&type=style&index=0&id=4973a7b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports